import { Modal } from "d-react-components";
import { useFormik } from "formik";
import React from "react";
import InputTextForm from "../../../common/input/InputTextForm";
import Messages from "../../../languages/Messages";

interface IOrderCrudContactModal {
    open: boolean;
    defaultValue: any;
    onClose: () => void;
    onChange: (value: any) => void;
}

const OrderCrudContactModal = ({
    open,
    defaultValue,
    onClose,
    onChange,
}: IOrderCrudContactModal) => {
    const contactForm = useFormik<any>({
        initialValues: defaultValue,
        validateOnChange: false,
        validateOnBlur: false,
        onSubmit: (values) => {
            onChange(values);
            onClose();
        },
    });

    return (
        <Modal
            open={open}
            onClose={onClose}
            title={Messages.updateContact}
            onSave={() => contactForm.handleSubmit()}
        >
            <div className="row">
                <InputTextForm
                    keyData="firstName"
                    form={contactForm}
                    className="col-6 mt-3"
                />
                <InputTextForm
                    keyData="lastName"
                    form={contactForm}
                    className="col-6 mt-3"
                />
                <InputTextForm
                    keyData="email"
                    form={contactForm}
                    className="col-6 mt-3"
                />
                <InputTextForm
                    keyData="phone"
                    form={contactForm}
                    className="col-6 mt-3"
                />
            </div>
        </Modal>
    );
};

export default OrderCrudContactModal;
